import { render } from "./down.vue?vue&type=template&id=3b80f78d&scoped=true"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"

import "./down.vue?vue&type=style&index=0&id=3b80f78d&scoped=true&lang=css"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b80f78d"]])

export default __exports__